module.exports = __webpack_public_path__ + "img/coal.078c4ba.jpg";